var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"mr-10 pr-5 clickable",on:{"click":_vm.clickAction}},[_vm._v(" "+_vm._s(_vm.routeName=='Home'?'Login':'Home')+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }